import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      return res.data
    }
    return res.data
  },
  error => {
    return Promise.resolve({})
  }
)

export default service
